import { useEffect, useState } from "react";
import { Button, Form } from "antd";

const FormSubmitButton = ({
  form,
  label,
  disabled = false,
  buttonProps = {},
}) => {
  const [submittable, setSubmittable] = useState(false);

  // Watch all values
  const values = Form.useWatch([], form);
  useEffect(() => {
    form
      .validateFields({
        validateOnly: true,
      })
      .then(
        () => {
          setSubmittable(true);
        },
        () => {
          setSubmittable(false);
        }
      );
  }, [values, form]);

  return (
    <Button
      type="primary"
      htmlType="submit"
      disabled={!submittable || disabled}
      {...buttonProps}
    >
      {label}
    </Button>
  );
};

export default FormSubmitButton;
